import * as nearAPI from "near-api-js";
import React, { useCallback, useEffect, useState } from "react";

const { KeyPair, keyStores, connect, WalletConnection, utils: { format: {formatNearAmount}} } = nearAPI;

const keyStore = new keyStores.BrowserLocalStorageKeyStore();

export const STAKING_CONTRACT_ID = "kokumokongz_staking_wallet.near"
export const TOKEN_CONTRACT_ID = "kokumokongz_token_wallet.near"
export const NFT_CONTRACT_ID = "kokumokongz.near"
export const GAS_FOR_NFT_APPROVE = "20000000000000";
export const GAS_FOR_RESOLVE_TRANSFER = "10000000000000";
export const MAX_GAS = "300000000000000";
export const DEPOSIT = "520000000000000000000";

export const WalletContext = React.createContext({
    near: undefined,
    wallet: undefined,
    nftList: [],
    plasmabalance: 0,
    setplasmabalance: () => { },
    stakedNftList: [],
    fetchNFTs: () => { },
    fetchStakedNFTs: () => { },
})

// connect to NEAR
const WalletProvider = (props) => {
    const [near, setNear] = useState()
    const [wallet, setWallet] = useState()
    const [nftList, setNftList] = useState([])
    const [stakedNftList, setStakedNftList] = useState([])
    const [plasmabalance, setplasmabalance] = useState(0)
  
    const config = {
        networkId: "mainnet",
        keyStore, // optional if not signing transactions
        nodeUrl: "https://rpc.mainnet.near.org",
        walletUrl: "https://wallet.mainnet.near.org",
        helperUrl: "https://helper.mainnet.near.org",
        explorerUrl: "https://explorer.mainnet.near.org",
    };
       
    const connectToNear = useCallback(async () => {
      try {
        const near = await connect(config);
        const wallet = new WalletConnection(near);
        setNear(near);
        setWallet(wallet);
        if(wallet && wallet.isSignedIn()){
          let result = await wallet.account().viewFunction(
            TOKEN_CONTRACT_ID,
            "ft_balance_of",
            {
              account_id: wallet.account().accountId,
            }
          ); 
          setplasmabalance(formatNearAmount(result));
          console.log("==============================", plasmabalance);
          result = await wallet.account().getAccessKeys();
          let tokenKeyExist = false;
          for(let i=0; i<result.length; i++){
            if(result[i].access_key.permission != 'FullAccess' && result[i].access_key.permission.FunctionCall.receiver_id == 'kokumokongz_token_wallet.near'){
              tokenKeyExist = true;
              break;
            }
          }
          if(tokenKeyExist == false){
            console.log("Adding AccessKey to Token");
            const keyPair = KeyPair.fromRandom("ed25519");
            const publicKey = keyPair.publicKey.toString();
            await keyStore.setKey(config.networkId, publicKey, keyPair);
            await wallet.account().addKey(publicKey, 'kokumokongz_token_wallet.near', [], '250000000000000000000000');
          }
        } else {
          setplasmabalance(0);
          console.log("==============================", plasmabalance);
        }
  
      } catch (error) {
        console.log(error, "error")
      }
    }, [config])
  
    const fetchNFTs = async (wallet) => {
      if(wallet && wallet.isSignedIn()){
        const items = await wallet.account().viewFunction(
          NFT_CONTRACT_ID,
          "nft_tokens_for_owner",
          {
            account_id: wallet.account().accountId,
            from_index: "0",
            limit: 1000
          }
        );
        if (!items || !items.length){
          setNftList([])
          return;
        }
        const contractMetaData = await wallet.account().viewFunction(
          NFT_CONTRACT_ID,
          "nft_metadata",
          {}
        );
        for (let item of items) {
          item.baseUri = contractMetaData.base_uri
        }
        setNftList(items)
      }
    }

    const fetchStakedNFTs = async (wallet) => {
      if(wallet && wallet.isSignedIn()){
        console.log(wallet.account().accountId);
        const stakedItemInfos = await wallet.account().viewFunction(
          STAKING_CONTRACT_ID,
          "get_staking_informations_by_owner_id",
          {
            account_id: wallet.account().accountId,
            from_index: "0",
            limit: 1000
          }
        );

        const items =[];
        for(let stakedItemInfo of stakedItemInfos){
          console.log(stakedItemInfo)
          const item = await wallet.account().viewFunction(
            NFT_CONTRACT_ID,
            "nft_token",
            {
              token_id: stakedItemInfo.token_id
            }
          );
          if(item)
            items.push(item);
        }
        if (!items || !items.length){
          setStakedNftList([])
          return;
        }
        const contractMetaData = await wallet.account().viewFunction(
          NFT_CONTRACT_ID,
          "nft_metadata",
          {}
        );
        for (let item of items) {
          item.baseUri = contractMetaData.base_uri
        }
        setStakedNftList(items)
      }
    }

    useEffect(() => {
    }, [connectToNear])
  
    useEffect(() => {
      connectToNear()
    }, [])
  
    return (
      <WalletContext.Provider
        value={{ near, wallet, nftList, stakedNftList, plasmabalance, fetchNFTs, fetchStakedNFTs, setplasmabalance}}
      >
        {props.children}
      </WalletContext.Provider>
    )
}
  
export default WalletProvider
